import { Dispatch } from "PFApp/search/search_context";
import { useDebounce } from "PFCore/helpers/use_debounce";
import { useDeterministicStringify } from "PFCore/helpers/use_deterministic_stringify";
import { SEARCH_ASYNC_ACTIONS } from "PFReducers/search_reducer/search_reducer";
import { Filters, OrderMeta, Value } from "PFTypes";
import { useEffect, useMemo } from "react";

import { getAPIFilters } from "../../use_filtered_collection";
import { useDebouncedMergeState } from "../helpers/use_debounced_merge_state";

type ProfilesSyncArgs = {
  dispatch: Dispatch;
  term: string;
  trimmedTerm: string;
  triggerCounter: number;
  profilesRequestFilters: Filters<Value>;
  profilesRequestOrder: Partial<OrderMeta>;
  profilesPage: number;
};

export const useProfilesSync = ({
  dispatch,
  term,
  trimmedTerm,
  triggerCounter,
  profilesRequestFilters,
  profilesRequestOrder,
  profilesPage
}: ProfilesSyncArgs) => {
  const stringify = useDeterministicStringify();
  const debouncedGoToPage1Dispatch = useDebouncedMergeState(dispatch);

  const profilesRequestAPIFilters = useMemo(
    () => getAPIFilters(profilesRequestFilters) || {},
    [profilesRequestFilters]
  );

  const profilesParamsHash = stringify([profilesRequestAPIFilters, profilesRequestOrder]);
  const fetchProfilesDebounced = useDebounce(
    () =>
      dispatch({
        type: SEARCH_ASYNC_ACTIONS.SEARCH_FETCH_PROFILES,
        payload: {
          term,
          profilesRequestOrder,
          profilesPage,
          profilesRequestFilters: profilesRequestAPIFilters
        }
      }),
    500
  );

  useEffect(() => {
    debouncedGoToPage1Dispatch({ profilesPage: 1 });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profilesParamsHash]);

  useEffect(() => {
    fetchProfilesDebounced();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [trimmedTerm, profilesPage, profilesParamsHash, triggerCounter]);
};
